import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'cerrix-title',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
    ],
    providers: [],
    templateUrl: './cerrix-title.component.html',
    styleUrl: './cerrix-title.component.scss'
})
export class CerrixTitleComponent implements OnInit, ControlValueAccessor {
  @Input() public value: string = '';
  @Input() public placeholder: string = '';
  @Input() public size: 'small' | 'large' | 'medium' = 'medium';
  @Input() public focus: boolean = false;
  @Input() public editable: boolean = true;
  @Input() public clipText: boolean = false;
  @Input() public showAsRequired: boolean = false;
  @Input() public dataUiid: string = "undefined"

  @ViewChild('input') protected input!: ElementRef;

  public onChange: any = () => {};
  public onTouched: any = () => {};

  protected ngControl = inject(NgControl, { optional: true, self: true });

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.focus) {
      this.focusInput();
    }
  }

  protected onEdit(): void {
    if (this.editable) {
      this.focus = true;
      this.focusInput();
    }
  }

  protected onInputBlur(): void {
    this.onTouched();
    this.focus = false;
  }

  writeValue(obj: string): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.editable = !isDisabled;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
  }

  private focusInput(): void {
    setTimeout(() => {
      this.input?.nativeElement.focus();
    }, 0);
  }
}
